<template>
    <div class="content-line-multiple" :id="content.Anker">
        <template v-for="value in content.Text">
            <div class="content-line-cell content-line-cell-equal">
                <Text :content="value"/>
            </div>
        </template>
    </div>
</template>

<script>
import Text from "@/components/elements/Text.vue";

export default {
    components: {Text},
    props: [
        "content"
    ],
}
</script>